import { type AlgoliaProductCard, type ProductCard, TAGS } from "@raumagarn/formatters";

export const getProductTag = (
	product: ProductCard | AlgoliaProductCard,
	currency: string | undefined,
) => {
	if (product.isNew) return TAGS.new;
	if (product.showAsOnSale) return TAGS.sale;
	if (product.cannonicalCategory === "Outlet") return TAGS.outlet;
	if (!currency) return null;
	if (product?.comingSoon?.includes(currency)) return TAGS.comingSoon;
	if (product?.outlet?.includes(currency)) return TAGS.outlet;
	if (Array.isArray(product?.freeRecipe) && product?.freeRecipe?.includes(currency))
		return TAGS.free;
	// if (product?.archive?.includes(currency)) return TAGS.archive;

	return null;
};
